import 'react';
import './Provider/ThemeContext.js';
import 'classnames';
import { css } from 'emotion';
import { css as css$1 } from '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import { a as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';
import './ColorMode/ColorModeContext.js';
import 'lodash/kebabCase';
import 'tinycolor2';
import { s as space, t as theme, j as breakpoint, p as palette } from './getCSSFromStyleObject.js';
import 'lodash/uniq';
import 'reakit/Id';
import 'deepmerge';
import 'lodash/set';
import 'lodash/get';
import 'capsize';
import { getHiddenScrollbarStyles } from './utils/getHiddenScrollbarStyles.js';
import '@emotion/is-prop-valid';
import './utils/OutsideClickHandler.js';

function _templateObject30() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteralLoose(["\n      padding-top: ", ";\n    "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteralLoose(["\n      position: fixed;\n      width: 100%;\n    "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  min-height: ", ";\n  height: ", ";\n  border-bottom: 1px solid ", ";\n  z-index: 999;\n\n  & > * {\n    height: 100%;\n  }\n\n  ", "\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteralLoose(["\n  min-height: 100vh;\n  position: relative;\n\n  & .bb-PageWithSidebarSidebarExpandedWrapper {\n    top: ", ";\n  }\n\n  & .bb-PageWithSidebarSidebar {\n    height: calc(100vh - ", ");\n  }\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteralLoose(["\n      display: none;\n    "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteralLoose(["\n  &&& {\n    min-width: ", ";\n    overflow-y: scroll;\n\n    ", ";\n  }\n\n  ", ";\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteralLoose(["\n      display: none;\n    "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteralLoose(["\n      right: 0;\n    "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  z-index: 999999;\n  overflow-y: scroll;\n\n  ", ";\n\n  ", "\n\n  ", ";\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteralLoose(["\n      overflow: visible;\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteralLoose(["\n      border-left: 1px solid ", ";\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose(["\n      border-right: 1px solid ", ";\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  height: 100vh;\n  min-width: ", ";\n  width: ", ";\n  transform: translateX(0px);\n\n  ", "\n\n  ", "\n\n  ", "\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n        padding-right: 0px;\n      "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n          padding-right: 0px;\n        "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n      padding-right: ", ";\n\n      ", "\n\n      ", "\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n        padding-left: 0px;\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n          padding-left: 0px;\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n      padding-left: ", ";\n\n      ", "\n\n      ", "\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n\n  ", "\n  ", "\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  min-height: 100vh;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      padding-top: ", "rem;\n      padding-bottom: ", "rem;\n\n      & {\n        ", ";\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      padding: ", "rem ", "rem;\n\n      & {\n        ", ";\n      }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", "rem ", "rem;\n\n  ", "\n\n  ", "\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var PageContent = function PageContent(styleProps) {
  return css(_templateObject(), space(4, 'major')(styleProps), space(2, 'major')(styleProps), styleProps.isFluid && css$1(_templateObject2(), space(4, 'major')(styleProps), theme('Container.fluidMargin')(styleProps), theme(styleProps.themeKey, "styles.fluid")(styleProps)), breakpoint('max-tablet', css$1(_templateObject3(), space(2, 'major')(styleProps), space(2, 'major')(styleProps), theme(styleProps.themeKey, "styles.mobile")(styleProps)))(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageContentWrapper = function PageContentWrapper(styleProps) {
  return css(_templateObject4(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithSidebar = function PageWithSidebar(styleProps) {
  return css(_templateObject5(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithSidebarContent = function PageWithSidebarContent(styleProps) {
  return css(_templateObject6(), styleProps.sidebarPlacement === 'left' && css$1(_templateObject7(), getWidth(styleProps), breakpoint("max-" + styleProps.collapseBelow, css$1(_templateObject8()))(styleProps), !styleProps.isSidebarOpen && css$1(_templateObject9())), styleProps.sidebarPlacement === 'right' && css$1(_templateObject10(), getWidth(styleProps), breakpoint("max-" + styleProps.collapseBelow, css$1(_templateObject11()))(styleProps), !styleProps.isSidebarOpen && css$1(_templateObject12())), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithSidebarSidebar = function PageWithSidebarSidebar(styleProps) {
  return css(_templateObject13(), palette('background')(styleProps), getWidth(styleProps), getWidth(styleProps), styleProps.sidebarPlacement === 'left' && css$1(_templateObject14(), palette('white800', {
    dark: 'gray700'
  })(styleProps)), styleProps.sidebarPlacement === 'right' && css$1(_templateObject15(), palette('white800', {
    dark: 'gray700'
  })(styleProps)), styleProps.isSidebarMinimized && css$1(_templateObject16()), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithSidebarSidebarExpandedWrapper = function PageWithSidebarSidebarExpandedWrapper(styleProps) {
  return css(_templateObject17(), getHiddenScrollbarStyles(), styleProps.sidebarPlacement === 'right' && css$1(_templateObject18()), breakpoint("max-" + styleProps.collapseBelow, css$1(_templateObject19()))(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithSidebarSidebarCollapsedWrapper = function PageWithSidebarSidebarCollapsedWrapper(styleProps) {
  return css(_templateObject20(), styleProps.collapsedSidebarWidth, getHiddenScrollbarStyles(), breakpoint("max-" + styleProps.collapseBelow, css$1(_templateObject21()), {
    else: css$1(_templateObject22())
  })(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithSidebarDisclosure = function PageWithSidebarDisclosure(styleProps) {
  return css(_templateObject23(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithSidebarMinimize = function PageWithSidebarMinimize(styleProps) {
  return css(_templateObject24(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithHeader = function PageWithHeader(styleProps) {
  return css(_templateObject25(), styleProps.headerHeight, styleProps.headerHeight, theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithHeaderHeader = function PageWithHeaderHeader(styleProps) {
  return css(_templateObject26(), palette('background')(styleProps), styleProps.headerHeight, styleProps.headerHeight, palette('white800', {
    dark: 'gray700'
  })(styleProps), styleProps.sticky && css$1(_templateObject27()), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithHeaderContent = function PageWithHeaderContent(styleProps) {
  return css(_templateObject28(), styleProps.sticky && css$1(_templateObject29(), styleProps.isHeaderOpen ? styleProps.headerHeight : 'unset'), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var PageWithHeaderDisclosure = function PageWithHeaderDisclosure(styleProps) {
  return css(_templateObject30(), theme(styleProps.themeKey, "styles.base")(styleProps));
};

function getWidth(styleProps) {
  if (styleProps.isSidebarMinimized) {
    return styleProps.minimizedSidebarWidth;
  }

  if (styleProps.isCollapsed) {
    return styleProps.collapsedSidebarWidth;
  }

  return styleProps.sidebarWidth;
}

var Page_styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  PageContent: PageContent,
  PageContentWrapper: PageContentWrapper,
  PageWithSidebar: PageWithSidebar,
  PageWithSidebarContent: PageWithSidebarContent,
  PageWithSidebarSidebar: PageWithSidebarSidebar,
  PageWithSidebarSidebarExpandedWrapper: PageWithSidebarSidebarExpandedWrapper,
  PageWithSidebarSidebarCollapsedWrapper: PageWithSidebarSidebarCollapsedWrapper,
  PageWithSidebarDisclosure: PageWithSidebarDisclosure,
  PageWithSidebarMinimize: PageWithSidebarMinimize,
  PageWithHeader: PageWithHeader,
  PageWithHeaderHeader: PageWithHeaderHeader,
  PageWithHeaderContent: PageWithHeaderContent,
  PageWithHeaderDisclosure: PageWithHeaderDisclosure
});

export { Page_styles as P, PageContent as a, PageContentWrapper as b, PageWithHeaderDisclosure as c, PageWithSidebarDisclosure as d, PageWithSidebarMinimize as e, PageWithSidebar as f, PageWithSidebarSidebar as g, PageWithSidebarSidebarExpandedWrapper as h, PageWithSidebarSidebarCollapsedWrapper as i, PageWithSidebarContent as j, PageWithHeader as k, PageWithHeaderHeader as l, PageWithHeaderContent as m };
